export const withLoading = async (callback, { state, commit }) => {
  commit("setLoading", true)
  try {
    const result = await callback()
    return result
  } finally {
    commit("setLoading", false)
  }
}